<script setup lang="ts">
import { BaseButton, FieldSelect } from '@magma-app/magma-lapilli';

import type {
  SlideOverCampaignCriteriaItem,
  SlideOverReactivationForm,
  SlideOverSelectOption,
} from './types';

defineProps<{
  campaignCriteria: SlideOverCampaignCriteriaItem[] | undefined;
  form: SlideOverReactivationForm;
  getCriteriaOptions: (criteriaId: number) => SlideOverSelectOption[];
  hasAllCriteriaSelected: boolean;
  isLoading: boolean;
}>();

const emit = defineEmits<{
  (event: 'confirm'): void;
  (event: 'cancel'): void;
}>();
</script>

<template>
  <div class="pt-8 lg:pt-0">
    <svg
      class="mx-auto"
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="3" width="32" height="32" rx="16" fill="#E0EAFF" />
      <path
        d="M24.3333 25V23.6667C24.3333 22.9594 24.0523 22.2811 23.5522 21.781C23.0521 21.281 22.3739 21 21.6666 21H16.3333C15.626 21 14.9478 21.281 14.4477 21.781C13.9476 22.2811 13.6666 22.9594 13.6666 23.6667V25M21.6666 15.6667C21.6666 17.1394 20.4727 18.3333 19 18.3333C17.5272 18.3333 16.3333 17.1394 16.3333 15.6667C16.3333 14.1939 17.5272 13 19 13C20.4727 13 21.6666 14.1939 21.6666 15.6667Z"
        stroke="#444CE7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <rect
        x="3"
        y="3"
        width="32"
        height="32"
        rx="16"
        stroke="#E0EAFF"
        stroke-opacity="0.4"
        stroke-width="6"
      />
    </svg>

    <span
      class="mx-auto mt-6 block text-center text-mgm-txt-md font-medium text-foreground-emphasis"
    >
      {{ $t('slideOverModal.reactivate.update') }}
    </span>

    <FieldSelect
      v-for="campaignCriteriaItem in campaignCriteria"
      :id="campaignCriteriaItem.criteriaId"
      :key="campaignCriteriaItem.criteriaId"
      v-model="form.criteria[campaignCriteriaItem.criteriaId]"
      class="mt-4"
      :label="campaignCriteriaItem.criteria?.labelHelper"
      :options="getCriteriaOptions(campaignCriteriaItem.criteriaId)"
      :multiple="campaignCriteriaItem.criteria?.type === 'multiSelect'"
      :required="true"
    />

    <BaseButton
      class="mt-[18px] w-full"
      :text="$t('slideOverModal.reactivate.cta')"
      size="md"
      :disabled="!hasAllCriteriaSelected || isLoading"
      @click="emit('confirm')"
    />

    <BaseButton
      class="mt-2 w-full"
      :text="$t('generic.cancel')"
      size="md"
      state="scdr"
      @click="emit('cancel')"
    />
  </div>
</template>
